import { Visibility, VisibilityOff } from "@mui/icons-material";
import { Link } from "react-router-dom";
import CustomTextField from "../../Custom/CustomTextField";
import { Button } from "@mui/material";
import { InputAdornment, IconButton } from "@mui/material";
import { useState } from "react";

const LoginFormContent = ({
  formData,
  handleInputChange,
  handleSubmit,
  loading,
}) => {
  const [passwordType, setPasswordType] = useState("password");

  function showPassword() {
    setPasswordType((prev) => (prev === "password" ? "text" : "password"));
  }
  return (
    <div className="form-container">
      <form onSubmit={handleSubmit} name="login-form">
        <div className="access-header">
          <h2 className="form-title">Welcome Back!</h2>
          <p>Log into your account to continue</p>
        </div>
        <CustomTextField
          label="Username"
          name="username"
          color="black"
          variant="filled"
          required
          value={formData.username}
          onChange={handleInputChange}
        />
        <div className="password-container">
          <CustomTextField
            required
            label="Password"
            type={passwordType}
            name="password"
            prependIcon="eye"
            color="black"
            value={formData.password}
            onChange={handleInputChange}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={showPassword}
                    edge="end"
                    style={{
                      marginRight: "0rem",
                    }}
                  >
                    {passwordType === "text" ? (
                      <Visibility />
                    ) : (
                      <VisibilityOff />
                    )}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <Link to="/forgot-password" className="no-decor-link">
            Forgot password?
          </Link>{" "}
        </div>
        <Button
          variant="contained"
          type="submit"
          color="black"
          disableElevation
          disabled={Object.values(formData).some((x) => x === "") || loading}
        >
          {!loading ? "login" : "Loading..."}
        </Button>
        <div className="bottom-actions">
          Don't have an account?
          <Link to="/register" className="no-decor-link">
            Sign Up
          </Link>
        </div>
      </form>
    </div>
  );
};

export default LoginFormContent;
